import { c as _c } from "react/compiler-runtime";
import { useLocale } from 'next-intl';
import { Links, QuickLinks } from '@/components/QuickLinks';
import TextLink from '@/components/TextLink';
import { RailsRoutes } from '@/helpers/utils';
import { Locale } from '@/i18n/types';
function getDonationsUrl(locale: Locale, fundraisingEventId: string) {
  const donationsUrl = new URL(RailsRoutes.listDonationsInBO({
    locale
  }));
  const donationsUrlParams = {
    'q[receiver_id_eq]': fundraisingEventId,
    'q[receiver_type_eq]': 'FundraisingEvent'
  };
  for (const [key, value] of Object.entries(donationsUrlParams)) {
    donationsUrl.searchParams.set(key, value);
  }
  return donationsUrl.toString();
}
function getForwardingsUrl(locale: Locale, fundraisingEventId: string) {
  const forwardingsUrl = new URL(RailsRoutes.listDonationsInBO({
    locale
  }));
  const forwardingsUrlParams = {
    'q[sender_id_eq]': fundraisingEventId,
    'q[sender_type_eq]': 'FundraisingEvent'
  };
  for (const [key, value] of Object.entries(forwardingsUrlParams)) {
    forwardingsUrl.searchParams.set(key, value);
  }
  return forwardingsUrl.toString();
}
function FundraisingEventQuickLinks(t0) {
  const $ = _c(40);
  const {
    fundraisingEventId,
    publicFaceId,
    domain
  } = t0;
  const locale = useLocale();
  let t1;
  if ($[0] !== fundraisingEventId || $[1] !== locale) {
    t1 = getDonationsUrl(locale, fundraisingEventId);
    $[0] = fundraisingEventId;
    $[1] = locale;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const donationsUrl = t1;
  let t2;
  if ($[3] !== fundraisingEventId || $[4] !== locale) {
    t2 = getForwardingsUrl(locale, fundraisingEventId);
    $[3] = fundraisingEventId;
    $[4] = locale;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const forwardingsUrl = t2;
  const apiUrl = `https://api.${domain}/${locale}/api_v4/fundraising_events/${fundraisingEventId}.json/`;
  let t3;
  if ($[6] !== fundraisingEventId || $[7] !== locale) {
    t3 = RailsRoutes.editFundraisingEventInBO({
      locale,
      slug: fundraisingEventId
    });
    $[6] = fundraisingEventId;
    $[7] = locale;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t3) {
    t4 = <TextLink href={t3}>Edit</TextLink>;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== donationsUrl) {
    t5 = <TextLink href={donationsUrl}>Donations</TextLink>;
    $[11] = donationsUrl;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== forwardingsUrl) {
    t6 = <TextLink href={forwardingsUrl}>Forwardings</TextLink>;
    $[13] = forwardingsUrl;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== locale || $[16] !== publicFaceId) {
    t7 = RailsRoutes.editPublicFaceInBO({
      locale,
      id: publicFaceId
    });
    $[15] = locale;
    $[16] = publicFaceId;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t7) {
    t8 = <TextLink href={t7}>Public Face</TextLink>;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== locale || $[21] !== publicFaceId) {
    t9 = RailsRoutes.editUser({
      locale,
      id: publicFaceId
    });
    $[20] = locale;
    $[21] = publicFaceId;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== t9) {
    t10 = <TextLink href={t9}>Public Face edit</TextLink>;
    $[23] = t9;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== fundraisingEventId || $[26] !== locale) {
    t11 = RailsRoutes.editFundraisingEventManagers({
      locale,
      slug: fundraisingEventId
    });
    $[25] = fundraisingEventId;
    $[26] = locale;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== t11) {
    t12 = <TextLink href={t11}>Permissions</TextLink>;
    $[28] = t11;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== apiUrl) {
    t13 = <TextLink href={apiUrl}>API v4</TextLink>;
    $[30] = apiUrl;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t10 || $[33] !== t12 || $[34] !== t13 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6 || $[38] !== t8) {
    t14 = <QuickLinks id="fundraising-event-quick-links"><Links>{t4}{t5}{t6}{t8}{t10}{t12}{t13}</Links></QuickLinks>;
    $[32] = t10;
    $[33] = t12;
    $[34] = t13;
    $[35] = t4;
    $[36] = t5;
    $[37] = t6;
    $[38] = t8;
    $[39] = t14;
  } else {
    t14 = $[39];
  }
  return t14;
}
export default FundraisingEventQuickLinks;